export default function Platform() {
  return (
    <section id="platform" className="lp-sec">
      <div className="lp-wrap">
        <h2 className="lp-h2" style={{ margin: '0 0 16px', maxWidth: 760 }}>
          One platform for everyone in the transaction.
        </h2>
        <p className="lp-lede" style={{ margin: '0 0 clamp(36px,4vw,56px)', maxWidth: 640 }}>
          The same program, the same data, the same rules. Each role gets the view
          its job requires.
        </p>

        <div className="lp-cards">
          <article className="lp-card">
            <div className="lp-panel lp-panel--dark" style={{ minHeight: 190, gap: 10 }}>
              <div className="lp-panel__label">PROGRAM · COUNTER-UAS SENSOR</div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'auto 1fr',
                  gap: '8px 12px',
                  alignItems: 'center',
                }}
              >
                <span className="lp-dot" /><span>Gap defined · 4 KPPs</span>
                <span className="lp-dot" /><span>11 offerings assessed</span>
                <span className="lp-dot" /><span>Pathway: CSO under OTA</span>
                <span className="lp-dot lp-dot--open" />
                <span style={{ color: 'var(--d-muted)' }}>Acquisition strategy · drafting</span>
              </div>
              <div className="lp-prog">
                <i style={{ flex: 3, background: 'var(--amber)' }} />
                <i style={{ flex: 1, background: 'var(--d-rule)' }} />
              </div>
            </div>
            <div>
              <div className="lp-card__eyebrow">FOR BUYING OFFICES</div>
              <h3 className="lp-card__name">Overmatch Agent</h3>
              <p>
                Full program planning and execution in one place, from the
                capability gap to a fielded capability.
              </p>
            </div>
          </article>

          <article className="lp-card">
            <div className="lp-panel lp-panel--dark" style={{ minHeight: 190, gap: 12 }}>
              <div className="lp-panel__label">PORTFOLIO · 38 PROGRAMS · TIME TO AWARD</div>
              <div style={{ display: 'grid', gap: 8, fontSize: 12 }}>
                {[
                  { o: 'Office A', w: '42%', d: '41 d', c: 'var(--amber)' },
                  { o: 'Office B', w: '88%', d: '96 d', c: 'var(--d-faint)' },
                  { o: 'Office C', w: '61%', d: '67 d', c: 'var(--d-faint)' },
                ].map((r) => (
                  <div
                    key={r.o}
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '82px 1fr auto',
                      gap: 10,
                      alignItems: 'center',
                    }}
                  >
                    <span style={{ color: 'var(--d-muted)' }}>{r.o}</span>
                    <div className="lp-bar">
                      <i style={{ width: r.w, background: r.c }} />
                    </div>
                    <span>{r.d}</span>
                  </div>
                ))}
              </div>
              <div className="lp-panel__foot--muted">
                Office A&rsquo;s route reused by 6 programs this quarter
              </div>
            </div>
            <div>
              <div className="lp-card__eyebrow">FOR ACQUISITION LEADERS</div>
              <h3 className="lp-card__name">Overmatch Exec</h3>
              <p>
                Portfolio-wide visibility, scorecards drawn from the work itself,
                and the means to standardize what works.
              </p>
            </div>
          </article>

          <article className="lp-card">
            <div className="lp-panel lp-panel--dark" style={{ minHeight: 190, gap: 10 }}>
              <div className="lp-panel__label">VENDOR PROFILE · MATCHES</div>
              <div style={{ display: 'grid', gap: 8 }}>
                <div className="lp-panel__row lp-panel__row--wide lp-panel__amber">
                  <span>Maritime ISR sensor · PEO Littoral Sensing</span>
                  <span>Strong fit</span>
                </div>
                <div className="lp-panel__row lp-panel__row--wide">
                  <span>Expeditionary comms · Expeditionary Systems Office</span>
                  <span>Partial fit</span>
                </div>
              </div>
              <div className="lp-panel__foot--muted">
                Profile current · certifications verified 3 days ago
              </div>
            </div>
            <div>
              <div className="lp-card__eyebrow">
                FOR VENDORS <em>COMING SOON</em>
              </div>
              <h3 className="lp-card__name">Overmatch Gateway</h3>
              <p>
                One profile, kept current, matched to the offices actively
                defining a requirement you can meet.
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>
  )
}
